import { Component, inject, input, output, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReportRow, EditorReportTemplate, SelectOption } from '@xmedical/core';
import { ReportControlEditorService } from '../../services';

@Component({
  selector: 'xmed-report-title-renderer',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
  ],
  providers: [DatePipe],
  templateUrl: './report-title-renderer.component.html',
  styleUrl: './report-title-renderer.component.scss'
})
export class ReportTitleRendererComponent implements OnInit {
  private editorService = inject(ReportControlEditorService);
  private datePipe = inject(DatePipe);

  entryOptions = input<SelectOption[]>([]);
  template = input.required<EditorReportTemplate>();
  row = input.required<ReportRow>();

  procedureEntryChange = output<number>();

  value: Date = new Date();

  ngOnInit(): void {
    const r = this.row();
    if (r?.titleDateValue !== '') {
      this.value = new Date(r.titleDateValue);
    } else {
      this.value = new Date();
      r.titleDateValue = this.dateFormatter(this.value);
      this.editorService.triggerEvent();
    }
  }

  onValueChanges(date: Date): void {
    this.row().titleDateValue = this.dateFormatter(date);
    this.editorService.triggerEvent();
  }

  onProcedureEntryChange(): void {
    this.procedureEntryChange.emit(this.template().procedureEntryId);
  }

  private dateFormatter(date: Date): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd') ?? '';
  }
}
